import { useSelector } from 'react-redux'

import {
  selectAll,
  selectCompanyGroupsData,
  selectCompanyGroupsFetched,
  selectCompanyStructureSyncStatus
} from 'redux/selectors/CompanyGroups'

export const useCompanyGroups = () => {
  return useSelector(selectAll)
}

export const useCompanyGroupsData = () => {
  return useSelector(selectCompanyGroupsData)
}

export const useCompanyGroupsFetched = () => {
  return useSelector(selectCompanyGroupsFetched)
}

export const useCompanyStructureSyncStatus = () => {
  return useSelector(selectCompanyStructureSyncStatus)
}
